<template>
  <div class="membership-point-expiration-parts">
    <p class="membership-point-expiration-parts__information">
      <span class="membership-point-expiration-parts__point">{{ point.toLocaleString() }}P</span>
      <span class="membership-point-expiration-parts__date"
        >：{{ $tc('MypagePage.MypageTopPage.point.expirationDate') }} {{ expirationDate }}</span
      >
    </p>
    <p class="membership-point-expiration-parts__detail">
      <router-link
        :to="`/mypage/point-expiration-date?backLink=${backLink}`"
        class="membership-point-expiration-parts__detail-link"
        >{{ $tc('MypagePage.MypageTopPage.point.linkText') }}</router-link
      >
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { PointExpirationBackLinkType } from '@/views/MypagePage/MypagePointExpirationDatePage.vue'

export default defineComponent({
  name: 'MembershipPointExpirationParts',
  props: {
    /**
     * 表示するポイント
     */
    point: {
      type: Number,
    },
    /**
     * 表示する失効日
     */
    expirationDate: {
      type: String,
    },
    /**
     * 戻るボタンで戻る画面を指定
     */
    backLink: {
      type: String as PropType<PointExpirationBackLinkType>,
      default: 'mypage',
    },
  },
})
</script>

<style scoped lang="scss">
.membership-point-expiration-parts {
  display: flex;
  gap: 20px;
  align-items: center;

  &__point {
    font-size: 11px;
    font-weight: 600;
    color: $white;
    letter-spacing: 0.04em;
  }

  &__date {
    margin-left: 3px;
    font-family: $fontSignup;
    font-size: 10px;
    font-weight: 600;
    color: $white;
    letter-spacing: 0.04em;
  }

  &__detail {
    &-link {
      font-size: 10px;
      font-weight: 700;
      color: $white70;
      letter-spacing: 0.016em;
      text-decoration: underline;
    }
  }
}
</style>
